import React, { Component } from 'react';
import { Text, View, StyleSheet, Platform, TouchableWithoutFeedback, Dimensions } from 'react-native';
import { ShoppingItem } from 'fitbeat.models';
import { buildQuantityString } from 'fitbeat.models';
import Theme from '../../theme';
import { RoundCheckBox } from '../../ui';
import { translate } from 'react-i18next';
import { scaleText, defaultScale } from '../../utils/scaling';
const width = Dimensions.get('window').width;
const isMobile = width <= 550;

type PlaceholderTypeWhenConvertedToTsx = any;

interface IProps {
  categoryItems: ShoppingItem[];
  title: PlaceholderTypeWhenConvertedToTsx;
  indexOfCategoryItems: PlaceholderTypeWhenConvertedToTsx;
  toggleShoppingListItem: PlaceholderTypeWhenConvertedToTsx;
  t: PlaceholderTypeWhenConvertedToTsx;
}

export class ShoppingListFoodCategory extends Component<IProps> {
  public render() {
    const { title, categoryItems = [], indexOfCategoryItems, toggleShoppingListItem, t } = this.props;
    return (
      <View style={styles.container}>
        {
          categoryItems.map(item => {
            return (
              <View style={styles.bodyGroupButton}>
                <TouchableWithoutFeedback onPress={() => { toggleShoppingListItem(indexOfCategoryItems, categoryItems.indexOf(item), title); }}>
                  <View style={styles.settingCheckboxContainer}>
                    <View style={styles.bodyRadioButtonContainer}>
                      <RoundCheckBox
                        isActive={item.isCheckedFromShoppingList}
                        onPress={() => { toggleShoppingListItem(indexOfCategoryItems, categoryItems.indexOf(item), title); }}
                      />
                    </View>
                    <View style={styles.textContainer}>
                      <Text style={item.isCheckedFromShoppingList ? styles.textContainerCross : styles.accordionItem}>
                        {buildQuantityString(item)}
                      </Text>
                    </View>
                  </View>
                </TouchableWithoutFeedback>
              </View>
            );
          })
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    borderBottomWidth: 1,
    borderBottomColor: Theme.GREY_LIGHT,
    paddingHorizontal: defaultScale(10),
    paddingVertical: defaultScale(10),
    backgroundColor: Theme.WHITE
  },
  heading: {
    fontFamily: Theme.Custom700,
    fontSize: 16,
    color: Theme.GREY_MEDIUM,
    paddingBottom: 10,
    paddingTop: 10,
  },
  textContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    width:'90%'
  },
  bodyGroupButton: {
    flex: 1,
    flexDirection: 'row',
    paddingVertical: defaultScale(10),
    paddingTop: 0,
    paddingLeft: 0,
  },
  settingCheckboxContainer: {
    minHeight: defaultScale(30),
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    width:'100%',
  },
  bodyRadioButtonContainer: {
    width: '10%',
    justifyContent: 'center',
  },
  textContainerCross: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.GREY,
    textDecorationLine: 'line-through',
  },
  accordionItem: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.DARK_CHARCOAL,
  },
});

// export default ShoppingListFoodCategory
export default translate(['nutrition'], { wait: true })(ShoppingListFoodCategory);
